import { extendTheme, theme as base } from "@chakra-ui/react";
import { mode } from "@chakra-ui/theme-tools";
import { BiBorderRadius } from "react-icons/bi";

const styles = {
  global: (props) => ({
    body: {
      overflowX: "hidden",
      color: mode("black", "white")(props),
      bg: mode("gray.50", "#343A40")(props),
      fontFamily: "Helvetica, sans-serif",
    },
    html: {
      fontFamily: "Helvetica, sans-serif",
    },
    ".ql-container.ql-snow": {
      backgroundColor: mode("#ffffff", "#343A40")(props) + " !important",
      borderColor:
        mode("rgba(0, 0, 0, 0.16)", "rgba(255, 255, 255, 0.16)")(props) +
        " !important",
    },
    ".ql-snow": {
      backgroundColor: mode("#ffffff", "#343A40")(props) + " !important",
      borderTopRadius: "4px",
      borderColor:
        mode("rgba(0, 0, 0, 0.16)", "rgba(255, 255, 255, 0.16)")(props) +
        " !important",
    },
    ".ql-picker-options": {
      backgroundColor: mode("#ffffff", "#343A40")(props) + " !important",
      color: mode("black", "white")(props) + " !important",
    },
    ".ql-editor": {
      backgroundColor: mode("#ffffff", "#343A40")(props) + " !important",
    },
  }),
};

const colors = {
  gray: {
    700: "#1f2733",
  },
  navy: base.colors.navy || {
    50: "#d0dcfb",
    100: "#aac0fe",
    200: "#a3b9f8",
    300: "#728fea",
    400: "#3652ba",
    500: "#1b3bbb",
    600: "#24388a",
    700: "#1b254b",
    800: "#111c44",
    900: "#0b1437",
  },
  teal: base.colors.teal || {
    50: "#e0f2f1",
    100: "#b2dfdb",
    200: "#80cbc4",
    300: "#4db6ac",
    400: "#26a69a",
    500: "#009688",
    600: "#00897b",
    700: "#00796b",
    800: "#00695c",
    900: "#004d40",
  },
};

const customTheme = extendTheme({
  colors,
  styles,
});

export default customTheme;
